import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DateTime } from 'luxon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSegmentedModule } from 'ng-zorro-antd/segmented';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { take } from 'rxjs';
import { DateTimeSelectorComponent } from '../../basic/date-time-selector/date-time-selector.component';
import { AdminService } from '../../core/admin/admin.service';
import { SessionBackend } from '../../core/session/session';
import { StripeProductType } from '../../core/stripe/product.stripe';
import { UserClerkService } from '../../core/user/user-clerk.service';
import { WorkspaceComboBackend } from '../../core/workspace/workspace';

@Component({
  selector: 'app-admin',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    NzInputModule,
    NzButtonModule,
    NzIconModule,
    NzSegmentedModule,
    NzTabsModule,
    NzTableModule,
    NzRadioModule,

    DateTimeSelectorComponent,
  ],
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminComponent {
  constructor(
    private userClerkService: UserClerkService,
    private adminService: AdminService
  ) {}

  email?: string;

  subscriptionId?: string;

  workspaceList = signal<WorkspaceComboBackend[]>([]);

  currentWorkspace: WorkspaceComboBackend | undefined = undefined;

  ngOnInit() {
    if (this.userClerkService.getUser()?.publicMetadata['isAdmin'] === true) {
      this.isAdmin.set(true);
    }
  }

  trialTypeOptions = ['Basic', 'Premium'];
  trialIndex = 0;
  newExpiredTime?: DateTime;

  onWorkspaceListClick() {
    if (!this.email) {
      return;
    }

    this.adminService
      .getWorkspaceList$(this.email)
      .pipe(take(1))
      .subscribe((response: WorkspaceComboBackend[]) => {
        this.workspaceList.set(response);
      });
  }

  onWorkspaceChange(workspace: WorkspaceComboBackend) {
    if (workspace.publicSubData?.trialType === StripeProductType.basic) {
      this.trialIndex = 0;
    } else {
      this.trialIndex = 1;
    }

    if (workspace.publicSubData?.trialExpiredTimeStr) {
      this.newExpiredTime = DateTime.fromISO(workspace.publicSubData.trialExpiredTimeStr);

      console.log('trialExpiredTimeStr:', this.newExpiredTime);
    }

    console.log('new onWorkspaceChange tabIndex:', this.trialIndex);
  }

  onSaveWorkspaceDetailClick() {
    if (!this.currentWorkspace) {
      return;
    }

    if (!this.currentWorkspace?.publicSubData) {
      this.currentWorkspace!.publicSubData = {};
    }

    this.currentWorkspace!.publicSubData!.trialExpiredTimeStr = this.newExpiredTime?.toUTC().toISO() ?? '';
    this.currentWorkspace!.publicSubData!.trialType =
      this.trialIndex === 0 ? StripeProductType.basic : StripeProductType.premium;

    if (this.subscriptionId) {
      this.currentWorkspace.publicSubData.stripeSubscriptionIdList = [this.subscriptionId];
    }

    console.log('new this.currentWorkspace:', this.currentWorkspace.publicSubData);

    this.adminService
      .updateWorkspacePublicSubdata$(this.currentWorkspace.id, this.currentWorkspace.publicSubData)
      .pipe(take(1))
      .subscribe((response: WorkspaceComboBackend) => {
        this.currentWorkspace = response;
      });
  }

  getLocalTime(dateTimeStr?: string) {
    if (!dateTimeStr) {
      return '';
    }
    return DateTime.fromISO(dateTimeStr).toLocaleString(DateTime.DATETIME_SHORT);
  }

  isAdmin = signal<boolean>(false);

  sessionList = signal<SessionBackend[]>([]);

  userId = '';
  onGetRecordinglistClick() {
    this.adminService.getSessionList$(this.userId).subscribe((response: SessionBackend[]) => {
      response.sort(
        (a, b) => -DateTime.fromISO(a.createdTimeStr!).diff(DateTime.fromISO(b.createdTimeStr!)).as('seconds')
      );
      this.sessionList.set(response);
    });
  }
}
